export function formatUnderscoreToSpace(role) {
    if (role == null) return '';

    const normalized = String(role)
        .trim()
        // Replace underscores with spaces
        .replace(/_/g, ' ')
        // Normalize multiple spaces
        .replace(/\s+/g, ' ');

    if (!normalized) return '';

    return normalized
        .split(' ')
        .map((word) => {
            // Handle sub-modules with hyphens
            return word
                .split('-')
                .map((part) => {
                    if (!part) return '';

                    return part.charAt(0).toUpperCase() + part.slice(1);
                })
                .join('-');
        })
        .join(' ');
}